import types from '../constants/actionTypes'
import JsonApiRecordDecorator from '../json-api/JsonApiRecordDecorator';
import { API_READ, API_READ_FAILED } from 'redux-json-api/lib/constants';
import { reducer } from 'redux-json-api'

const clearLoadingEntities = (action, newState) => {
  if(action.payload.endpoint && newState.loadingEntities){
    Object.keys(newState.loadingEntities).forEach((key) => {
      if(key === action.payload.endpoint){
        delete newState.loadingEntities[key];
      }
    });
  }
}

export default function ApiReducer(state, action = {}) {
  let newState = Object.assign({}, state);
  let actionTypeToStateMap = {};

  actionTypeToStateMap[types.SET_CURRENT_ENTITY_VALUES] = function(){
    const currentEntity = Object.assign(new JsonApiRecordDecorator(), state.currentEntity, action.values);
    return Object.assign({}, state, { currentEntity });
  };
  actionTypeToStateMap[types.CREATE_CURRENT_ENTITY] = function(){
    const currentEntity = new JsonApiRecordDecorator();
    currentEntity.type = action.entityType;
    if (action.defaultValues) {
      Object.assign(currentEntity, action.defaultValues);
    }
    return Object.assign({}, state, { currentEntity, currentEntityType: action.entityType });
  };
  actionTypeToStateMap[types.SELECT_ENTITY] = function(){
    return Object.assign({}, state, { currentEntityId: action.entityId, currentEntityType: action.entityType })
  };
  actionTypeToStateMap[types.LAST_SELECTED_ENTITY] = function(){
    return Object.assign({}, state, { lastSelectedEntity: action.entityId })
  };
  actionTypeToStateMap[types.LAST_CREATED_ENTITY] = function(){
    return Object.assign({}, state, { lastCreatedEntity: action.entityId })
  };
  actionTypeToStateMap[types.CLEAR_LAST_SELECTED_ENTITY] = function(){
    delete newState.lastSelectedEntity;
    delete newState.lastCreatedEntity;
    return newState;
  };
  actionTypeToStateMap[types.SET_ACTIVE_PAGE] = function(){
    return Object.assign({}, state, { activePage: action.activePage });
  };
  actionTypeToStateMap[types.SET_ACTIVE_FILTERS] = function(){
    return Object.assign({}, state, { activeFilters: action.filters });
  };
  actionTypeToStateMap[types.SET_ACTIVE_SORT] = function(){
    return Object.assign({}, state, { activeSort: action.sort });
  };
  actionTypeToStateMap[types.SET_ACTIVE_SEARCH] = function(){
    return Object.assign({}, state, { activeSearch: action.search });
  };
  actionTypeToStateMap[types.SET_ACTIVE_STATE] = function(){
    return Object.assign({}, state, { activeState: action.state });
  };
  actionTypeToStateMap[types.RESET_ACTIVE_PROPS] = function(){
    return Object.assign({}, state, {
      activePage: undefined,
      activeFilters: undefined,
      activeSort: undefined,
      activeSearch: undefined,
      activeState: undefined
    });
  };
  actionTypeToStateMap[types.START_DOWNLOAD] = function(){
    return Object.assign({}, state, { downloadProcessing: true, downloadTimedOut: false });
  };
  actionTypeToStateMap[types.DOWNLOAD_SUCCESS] = function(){
    return Object.assign({}, state, { downloadProcessing: false, downloadUrl: action.downloadUrl });
  };
  actionTypeToStateMap[types.DOWNLOAD_FAIL] = function(){
    return Object.assign({}, state, { downloadProcessing: false, errorMessage: action.errorMessage });
  };
  actionTypeToStateMap[types.REPORT_TIMEOUT] = function (){
    return Object.assign({}, state, { downloadProcessing: false, downloadTimedOut: true });
  };
  actionTypeToStateMap[types.END_TIMEOUT] = function (){
    return Object.assign({}, state, { downloadProcessing: false, downloadTimedOut: false });
  };
  actionTypeToStateMap[types.CLEAR_MESSAGES] = function(){
    delete newState.errorMessage;
    delete newState.successMessage;
    delete newState.errorMessages;
    return newState;
  };
  actionTypeToStateMap[types.DISPLAY_ERROR] = function(){
    return Object.assign({}, state, { errorMessage: action.message });
  };

  actionTypeToStateMap[types.DISPLAY_ERRORS] = function(){
    return Object.assign({}, state, { errorMessages: action.errors });
  };

  actionTypeToStateMap[types.DISPLAY_SUCCESS] = function(){
    return Object.assign({}, state, { successMessage: action.message });
  };
  actionTypeToStateMap[types.CLEAR_API_STATE] = function(){
    delete newState[action.entity];
    delete newState.downloadUrl;
    return newState;
  };

  actionTypeToStateMap[types.ENTITY_WILL_READ] = function(){
    let entities = state.loadingEntities || {};
    entities[action.endpoint] = action.entity;
    return Object.assign({}, state, { loadingEntities: entities });
  }

  actionTypeToStateMap[API_READ] = function(){
    newState = reducer(state, action);
    if (action.payload.data && action.payload.data[0]){
      newState[action.payload.data[0].type].meta = action.payload.meta;
    }
    clearLoadingEntities(action, newState);
    return newState;
  };

  actionTypeToStateMap[API_READ_FAILED] = function(){
    newState = reducer(state, action);
    clearLoadingEntities(action, newState);
    return newState;
  };

  if (actionTypeToStateMap.hasOwnProperty(action.type)) {
    return actionTypeToStateMap[action.type]();
  }
  return reducer(state, action);
}
